import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import { MediaCardProps } from 'src/app/molecules/MediaCard/MediaCard';
import MediaCardCarouselWithTextBlock from 'src/app/molecules/MediaCardCarouselWithTextBlock/MediaCardCarouselWithTextBlock';
import { IStaticContentfulImages } from 'src/types/contentful';

const RealPeopleFeed = (): JSX.Element => {
  const assets = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      imageCard0: contentfulAsset(contentful_id: { eq: "6o0LTEiqxrIY1cFcd79Scy" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard1: contentfulAsset(contentful_id: { eq: "2wAwKfM2UFvjAQNdhJZnlW" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard2: contentfulAsset(contentful_id: { eq: "3oLDCFzqQ9KSKYONAU8OX2" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard3: contentfulAsset(contentful_id: { eq: "4cI6ql7K5U49K5azfq0rOS" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard4: contentfulAsset(contentful_id: { eq: "4jPswXADLzlxGsSDiSaGJI" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard5: contentfulAsset(contentful_id: { eq: "4etdv9HfLe8hT8ItRpliE6" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard6: contentfulAsset(contentful_id: { eq: "63LmplDxwvADRaEJRIE8TS" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard7: contentfulAsset(contentful_id: { eq: "2K6Hcuxo5K43DLdzI3Qos9" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard8: contentfulAsset(contentful_id: { eq: "jclet0LZFoJS0Rh2j65Kt" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard9: contentfulAsset(contentful_id: { eq: "41NBuVYpVYRHv3gVH2gSeP" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
      imageCard10: contentfulAsset(contentful_id: { eq: "MtLnlsZsFGCJtyZ7ul3N4" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1000)
      }
    }
  `);

  const imageMaxWidth = 360;

  const cards: MediaCardProps[] = [
    {
      image: {
        image: assets.imageCard0.gatsbyImageData,
        alt: 'Real People Image 0',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard1.gatsbyImageData,
        alt: 'Real People Image 1',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard2.gatsbyImageData,
        alt: 'Real People Image 2',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard3.gatsbyImageData,
        alt: 'Real People Image 3',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard4.gatsbyImageData,
        alt: 'Real People Image 4',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard5.gatsbyImageData,
        alt: 'Real People Image 5',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard6.gatsbyImageData,
        alt: 'Real People Image 6',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard7.gatsbyImageData,
        alt: 'Real People Image 7',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard8.gatsbyImageData,
        alt: 'Real People Image 8',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard9.gatsbyImageData,
        alt: 'Real People Image 9',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: assets.imageCard10.gatsbyImageData,
        alt: 'Real People Image 10',
      },
      imageMaxWidth,
    },
  ];

  return (
    <Grid>
      <MediaCardCarouselWithTextBlock
        heading={{
          type: 'heading',
          text: 'Real people. Real results.',
          size: 'lg',
          letterSpacing: -1,
        }}
        button={{
          children: 'Start Your Free Trial',
          href: 'https://cohost.mn.co?plan=free-trial',
          variant: 'primary',
          size: 'xl',
        }}
        cards={cards}
      />
    </Grid>
  );
};

export default RealPeopleFeed;
